<script lang="js">
import EventBus from '@/shared/services/event_bus';
import Session from '@/shared/services/session';
import Records from '@/shared/services/records';
import { startCase } from 'lodash-es';

export default {
  props: {
    topicItemId: Number
  },

  data() {
    return {
      show: false,
      newComment: null
    };
  },

  created() {
    EventBus.$on('toggle-reply', (itemable, topicItemId) => {
      if (topicItemId === this.topicItemId) {
        if (this.show) {
          this.show = false;
        } else {
          let body = ""; 
          const op = itemable.author();
          if (op.id !== Session.user().id) {
            if (Session.defaultFormat() === 'html') {
              body = `<p><span class=\"mention\" data-mention-id=\"${op.username}\" label=\"${op.name}\">@${op.nameOrUsername()}</span>&thinsp;</p>`;
            } else {
              body = `@${op.username} `;
            }
          }

          this.newComment = Records.comments.build({
            bodyFormat: Session.defaultFormat(),
            body,
            authorId: Session.user().id,
            topicId: itemable.topic().id,
            parentId: itemable.id,
            parentType: startCase(itemable.constructor.singular)
          });
          this.show = true;
        }
      }
    });
  },

  destroyed() {}
};
</script>

<template lang="pug">
.reply-form(v-if="show")
  //- p reply formwrapper {{itemable.constructor.singular}}

  comment-form(
    :comment="newComment"
    avatar-size="32"
    @comment-submitted="show = false"
    @cancel-reply="show = false"
    autofocus)


</template>
